<template>
	
	
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<!-- <el-button size="small" type="success" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('match.domain_set')}}</el-button> -->
		
		<span class="ml-3" @click="apiModel = true" style="cursor: pointer;color: rgb(64, 158, 255);font-size: 14px;">
									  
			<i class="el-icon-warning-outline mr-1"></i>{{$t('record.apiTis')}}
		</span>
		
		
		<span class="ml-3" @click="matchApiModel = true" style="cursor: pointer;color: rgb(64, 158, 255);font-size: 14px;">
									  
			<i class="el-icon-warning-outline mr-1"></i>全赛程数据
		</span>
		
	
		<el-button @click="comRuleModel = true" type="success" size="small" class="ml-3">用户开关</el-button>
		
		
		
		<el-tabs class="mt-3" v-model="type" @tab-click="handleClick" type="card">
		   <el-tab-pane  :label="$t('match.type1')" name="1"></el-tab-pane>
		   <el-tab-pane  :label="$t('match.type2')" name="2"></el-tab-pane>
		  <!-- <el-tab-pane  :label="$t('match.type0')" name="0"></el-tab-pane> -->
		   
		 </el-tabs>
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('match.id')" class="mb-0">
							<el-input size="small" clearable="" v-model="from.name" ></el-input>
						</el-form-item>
						
						
						<el-form-item :label="$t('match.com_name')" class="mb-0">
							<el-input size="small" clearable="" v-model="from.username" ></el-input>
						</el-form-item>
						
						
						<el-form-item :label="$t('match.short')" class="mb-0">
							<el-input size="small" clearable="" v-model="from.short" ></el-input>
						</el-form-item>
						
						<el-form-item :label="$t('match.home')" class="mb-0">
							<el-input size="small" clearable="" v-model="from.home" ></el-input>
						</el-form-item>
						
						<el-form-item :label="$t('match.away')" class="mb-0">
							<el-input size="small" clearable="" v-model="from.away" ></el-input>
						</el-form-item>
						
						
						
						
                      <!-- <el-form-item :label="$t('status.status')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('record.status')" :value="1"></el-option>
							</el-select>
						</el-form-item> -->
						
						<el-form-item :label="$t('match.time')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<!-- <el-button size="small" type="success" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('match.domain_set')}}</el-button> -->
						
						<!-- <span class="ml-3" @click="apiModel = true" style="cursor: pointer;color: rgb(64, 158, 255);font-size: 14px;">
													  
							<i class="el-icon-warning-outline mr-1"></i>{{$t('record.apiTis')}}
						</span> -->
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%"  @selection-change="handleSelectionChange">
				<el-table-column align="center" fixed prop="match_id" width="180" :label="$t('match.id')">
				</el-table-column>
				
				
				
				
				<el-table-column align="left" width="300" show-overflow-tooltip  prop="competition_name" :label="$t('match.com_name')">
					<template slot-scope="scope">
						<div style="display: flex;align-items: center;">
							<el-image
								style="width: 25px; height: 25px"
								:src="scope.row.competition_logo" 
								:preview-src-list="[scope.row.competition_logo]">
								
							</el-image>
							<span class="ml-2">{{scope.row.competition_name}}</span>
						</div>
					</template>
				</el-table-column>
				
				<el-table-column align="left" show-overflow-tooltip  prop="short_name_cn" width="180" :label="$t('match.short')">
				</el-table-column>
				
				<el-table-column align="left" width="250" show-overflow-tooltip  prop="home_name" :label="$t('match.home')">
					<template slot-scope="scope">
						<div style="display: flex;align-items: center;">
							<el-image
								style="width: 25px; height: 25px"
								:src="scope.row.home_logo" 
								:preview-src-list="[scope.row.home_logo]">
								
							</el-image>
							<span class="ml-2">{{scope.row.home_name}}</span>
						</div>
					</template>
				</el-table-column>
				
				<el-table-column align="left" width="250" show-overflow-tooltip  prop="away_name" :label="$t('match.away')">
					
					<template slot-scope="scope">
						<div style="display: flex;align-items: center;">
							<el-image
								style="width: 25px; height: 25px"
								:src="scope.row.away_logo" 
								:preview-src-list="[scope.row.away_logo]">
								
							</el-image>
							<span class="ml-2">{{scope.row.away_name}}</span>
						</div>
					</template>
					
				</el-table-column>
				
				
				
				<el-table-column align="center" width="180" show-overflow-tooltip  prop="away_name" :label="$t('match.type')">
					
					<template slot-scope="scope">
						<span v-if="scope.row.type_id==1">
							<i class="iconfont icon-zuqiu-copy"></i>
							{{$t('match.type1')}}
						</span>
						
						<span  v-if="scope.row.type_id==2">
							<i class="iconfont icon-lanqiu"></i>
							{{$t('match.type2')}}
						</span>
						
						<span  v-if="scope.row.type_id!=1 && scope.row.type_id!=2">
							{{scope.row.class_name}}
						</span>
						
					</template>
					
				</el-table-column>
			
				
				
				<el-table-column align="center" prop="match_time" width="180" :label="$t('match.time')">
				</el-table-column>
				
				
                
				
				<el-table-column align="center" width="120" fixed="right" :label="$t('layout.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<!-- <el-button v-if="scope.row.play_url" size="mini" plain type="success" v-auth="'editAdmin'" @click="openPlay(scope.row.play_url)">{{$t('live.look')}}</el-button> -->
							<el-button v-if="scope.row.is_play==1" @click="checkPlayInfo(scope.row)" v-auth="'delAdmin'" size="mini" plain type="primary">{{$t('match.plays')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		:style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		>
			<div style="flex: 1;" class="px-2">
				<el-pagination
				:current-page="page.current"
				:page-sizes="page.sizes"
				:page-size="page.size"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				background
				:layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
				:total="page.total"
				/>
			</div>
		</el-footer>
		
		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('match.plays') : $t('match.plays')"
			:visible.sync="infoModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			
			
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">

				<div  v-loading="infoLoad">
					<div v-if="info.is_have_pull==0">
						<div style="text-align: center;" class="mt-4">
							<div class="mb-3">请在 <strong>「配置信息 → 转推配置」</strong> 中完成播放域名的配置。</div>
							<div>仅当已设置播放域名后，系统才会生成并显示对应的播放地址。</div>
						</div>
						
					</div>
					
					<div v-if="info.is_have_pull==1">
						<!-- <div v-for="(item,index) in infoList" :key="index">
							{{item.cloud_name}}
						</div> -->
						
						
						  <el-table
						      :data="infoList" style="width: 100%">
							  <el-table-column show-overflow-tooltip="" align="center" width="100" prop="user_name" :label="$t('model.user')">
							  	<template slot-scope="scope">
							  		<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
							  		
							  	</template>
							  </el-table-column>
						      <el-table-column show-overflow-tooltip="" prop="cloud_name" :label="$t('match.cloud')" width="120" align="center">
						      </el-table-column>
							  
							  <el-table-column show-overflow-tooltip="" prop="push" :label="$t('live.type1')" width="140" align="center">
							  </el-table-column>
							  
							  <el-table-column show-overflow-tooltip="" prop="pull" :label="$t('live.type2')" width="140" align="center">
							  </el-table-column>
							  
							  
							  
							  <el-table-column show-overflow-tooltip prop="hls_url" :label="$t('match.plays')"  align="center">
							  </el-table-column>
							  
							  <el-table-column  prop="end_time" :label="$t('live.end_time')" width="180" align="center">
							  </el-table-column>
							  
							  <el-table-column prop="appname" label="App" width="100" align="center">
							  </el-table-column>
							  <el-table-column prop="stream" label="Stream" width="120" align="center">
							  </el-table-column>
							  
							  <el-table-column align="center" width="120" fixed="right" :label="$t('layout.operation')">
								  <template slot-scope="scope">
									  <el-button @click="copyText(scope.row.hls_url)" type="success" size="small">{{$t('match.copyPlay')}}</el-button>
								  </template>
								  
							  </el-table-column>
						      
						    </el-table>
					</div>
				</div>
				
		     
				
		
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="infoModel = false">{{$t('cdnd.close')}}</el-button>
				
			</div>
		</el-dialog>
		

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('match.domain_set') : $t('match.domain_set')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
				<div class="ml-4 mb-3">
					<el-tabs class="mt-1" v-model="form.open" type="card">
					   <el-tab-pane  :label="$t('match.set1')" name="1"></el-tab-pane>
					   <el-tab-pane  :label="$t('match.set2')" name="2"></el-tab-pane>
					   
					 </el-tabs>
				</div>
				 
				 
				 <!-- 基础设置 -->
				 <div v-if="form.open=='1'">
					 <!-- 接口key -->
					 <el-form-item    :label="$t('live.nowkey')" prop="api_key">
					 	<el-input @input="checkKeyInp2" v-model="form.api_key" :placeholder="$t('live.keyTis')" clearable size="small" style="width: 55%;"></el-input>
						<el-tooltip :content="$t('match.apikeyTis')" effect="dark" placement="top">
								
								<el-button size="mini" type="text">
									 <i class="el-icon-warning-outline ml-1" style="font-size: 16px;"></i>
								</el-button>
								
							</el-tooltip>
					 	<el-link class="ml-3 text-info" type="success" @click="rangKey(1)">{{$t('match.rand')}}</el-link>
					 	
					 </el-form-item>
					 <!-- IP白名单 -->
					 <el-form-item   :label="$t('match.ipw')" prop="ip_data">
					  	<el-input  @input="handleIpInput"  v-model="form.ip_data" type="textarea" :rows="4"  :placeholder="$t('match.inpipData')" clearable size="small" style="width: 55%;"></el-input>						<el-tooltip :content="$t('match.ipwTis')" effect="dark" placement="top">
								
								<el-button size="mini" type="text">
									 <i class="el-icon-warning-outline ml-1" style="font-size: 16px;"></i>
								</el-button>
								
							</el-tooltip>
					  </el-form-item>
					 <!-- 回调地址 -->
						<el-form-item    :label="$t('live.return')" prop="call_url">
							<el-input  v-model="form.call_url" :placeholder="$t('live.return')" clearable size="small" style="width: 55%;"></el-input>

							<el-tooltip :content="$t('match.callTis')" effect="dark" placement="top">
									
								<el-button size="mini" type="text">
									 <i class="el-icon-warning-outline ml-1" style="font-size: 16px;"></i>
								</el-button>
								
							</el-tooltip>
						</el-form-item>
						<!-- 鉴权key -->
						<el-form-item    :label="$t('live.returnKey')" prop="call_key">
							<el-input @input="checkKeyInp3" v-model="form.call_key" :placeholder="$t('live.keyTis')" clearable size="small" style="width: 55%;"></el-input>
							<el-tooltip :content="$t('match.callKeyTis')" effect="dark" placement="top">
									
									<el-button size="mini" type="text">
										 <i class="el-icon-warning-outline ml-1" style="font-size: 16px;"></i>
									</el-button>
									
								</el-tooltip>
							<el-link class="ml-3 text-info" type="success" @click="rangKey(2)">{{$t('match.rand')}}</el-link>
							
							
							
						</el-form-item>
				 </div>
				
				
               
				<!-- 转推设置 -->
				<div v-if="form.open=='2'">
					<div v-for="(item, index) in form.list" :key="index" class="px-5">
						<el-card class="box-card mt-3" >
							 <div slot="header" class="clearfix">
							    <span class="body_head">{{$t('match.tran')+(index+1)}}</span>
								
								<el-button  @click="removeTranscode(index)" v-if="form.list.length>1" class="float-right" size="mini" type="danger" icon="el-icon-close" circle></el-button>
							
							  </div>
							  
							 
							 <div>
								 <!-- 开关 -->
								 <el-form-item   :label="$t('match.status')" prop="url_auth">
								 	<div style="display: flex; align-items: center;">
										<el-switch
										  v-model="item.status"
										  active-color="#13ce66"
										  inactive-color="#999999">
										</el-switch>
										
										<el-tooltip :content="$t('match.statusTis')" effect="dark" placement="top">
												
												<el-button size="mini" type="text">
													 <i class="el-icon-warning-outline ml-1" style="font-size: 16px;"></i>
												</el-button>
												
											</el-tooltip>
									</div>
								 	
								 </el-form-item>
								 
								 <!-- 云服务商 -->
								 <el-form-item  
								 :label="$t('match.cloud')" 
								 :prop="`list.${index}.cloud_id`"
								 :rules="[{ required: true, message: $t('live.inpvideoBitrate'), trigger: 'blur' }]"
								 >
								 	
								 	<div style="display: flex;align-items: center;">
								 		
										
										<el-select  v-model="item.cloud_id" size="small" filterable :placeholder="$t('system.select')">
										</el-option>
											<el-option v-for="val in cloud" :key="val.id" :label="val.name" :value="val.id">
											</el-option>
										</el-select>
								 		
								 	</div>
								 	
								 </el-form-item>
								 <el-row>
									 <el-col :span="12">
										 <!-- 推流域名 -->
										 <el-form-item 
										 :prop="'list.' + index + '.push'"  
										 :rules="[{ required: true, message: $t('match.selpush'), trigger: 'blur' }]"
										 :label="$t('match.push')" 
										 >
										 	
										 	<el-input   size="small" style="width: 80%" :placeholder="$t('match.push')"   v-model="item.push">
										 	  </el-input>
										 	 <el-tooltip :content="$t('match.pushTis')" effect="dark" placement="top">
										 	 		
										 	 		<el-button size="mini" type="text">
										 	 			 <i class="el-icon-warning-outline ml-1" style="font-size: 16px;"></i>
										 	 		</el-button>
										 	 		
										 	 	</el-tooltip>
										 	  
										 </el-form-item>
									 </el-col>
									 <el-col :span="12">
										 <!-- 推流KEY -->
										 <el-form-item
										 :prop="'list.' + index + '.push_key'"  
										 :label="$t('match.pushKey')" 
										 >
										 	
										 	<el-input   size="small" style="width: 80%" :placeholder="$t('match.pushKey')"   v-model="item.push_key">
										 	  </el-input>
											  
											  <el-tooltip :content="$t('match.pushKeyTis')" effect="dark" placement="top">
											  		
											  		<el-button size="mini" type="text">
											  			 <i class="el-icon-warning-outline ml-1" style="font-size: 16px;"></i>
											  		</el-button>
											  		
											  	</el-tooltip>
										 	  
										 	  
										 </el-form-item>
									 </el-col>
								 </el-row>
								 
								 
								 
								 <el-row>
									 <el-col :span="12">
										 <!-- 播放域名 -->
										 <el-form-item 
										 :prop="'list.' + index + '.pull'"  
										 :label="$t('match.pull')" 
										 >
											
											<el-input   size="small" style="width: 80%" :placeholder="$t('match.pull')"   v-model="item.pull">
											  </el-input>
											 
											  <el-tooltip :content="$t('match.pullTis')" effect="dark" placement="top">
											  		
											  		<el-button size="mini" type="text">
											  			 <i class="el-icon-warning-outline ml-1" style="font-size: 16px;"></i>
											  		</el-button>
											  		
											  	</el-tooltip>
											  
										 </el-form-item>
									 </el-col>
									 <el-col :span="12">
										 <!-- 播放KEY -->
										 <el-form-item
										 :prop="'list.' + index + '.pull_key'"  
										 :label="$t('match.pullKey')" 
										 >

											<el-input   size="small" style="width: 80%" :placeholder="$t('match.pullKey')"   v-model="item.pull_key">
											  </el-input>
											  
											  <el-tooltip :content="$t('match.pushKeyTis')" effect="dark" placement="top">
											  		
											  		<el-button size="mini" type="text">
											  			 <i class="el-icon-warning-outline ml-1" style="font-size: 16px;"></i>
											  		</el-button>
											  		
											  	</el-tooltip>
											  
										 </el-form-item>
									 </el-col>
								 </el-row>
								
								 
								
								
								 
								 
								
								 
							
							 </div>
							
						  
						</el-card>
						
						
					</div>
					
					<div class="my-4 ml-5" v-if="con.is_more==1">
						<el-button @click="addTranscode" :disabled="form.list.length>=15" size="mini" type="success">{{$t('match.addTran')}}</el-button>
					</div>
				</div>

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" :loading="layout.loading" :disabled="layout.loading" @click="submit">{{$t('layout.save')}}</el-button>
			</div>
		</el-dialog>
		
		
		<el-dialog :close-on-click-modal="false"
			:title="$t('live.look')"
			:visible.sync="playModel"
			top="5vh"
			@opened="onDialogOpened"
			  @close="onDialogClosed"
			:width="layout.is_phone?'360px':'800px'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			
			<div v-loading="playData.load">
			      <!-- 使用 video.js 播放器容器 -->
			      <div v-if="isDialogOpened" class="video-wrapper">
			        <video
			          ref="videoPlayer"
			          class="video-js vjs-default-skin"
			          controls
			          preload="auto"
			        ></video>
			      </div>
		
			    </div>
			
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="playModel = false">{{$t('cdnd.close')}}</el-button>
				
			</div>
		</el-dialog>
		
		
		
		<el-dialog :close-on-click-modal="false"
				:title="$t('record.apiTis')"
				:visible.sync="apiModel"
				top="5vh"
				:width="layout.is_phone?'90%':'80%'"
				:append-to-body="true"
				custom-class="custom-dialog">
				<!-- 表单内容 -->
				
				 <template>
					 
					 <el-tabs  v-model="apiType" type="card">
					    <el-tab-pane  :label="$t('match.apiType1')" name="1"></el-tab-pane>
					    <el-tab-pane  :label="$t('match.apiType2')" name="2"></el-tab-pane>
					    
					  </el-tabs>
					  
					  
					<div class="doc-page" v-if="apiType=='2'">
						<el-card shadow="hover">
							<h4>{{$t('match.apitis16')}}</h4>
							<p class="desc">{{$t('match.apitis17')}}</p>
							<!-- 5. 响应示例 -->
							<el-divider>{{$t('match.apitis18')}}</el-divider>
							<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
								
								
							  <pre  style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none;">
	{
		"class_id": 1,
		"match_id": 4351100,
		"stream": "sd-1-4351100",
		"t": 1760786996,
		"hls_url": "http://play.example.com/live/sd-1-4351100.m3u8?txSecret=8e97dc1f8199fc15ac4ec8c31d7389c1&txTime=68F4CBB4",
		"sign": "6feafea640a7458f0a8e539a55c10a7e"
	}
							  </pre>
							  
							  
							</el-card>
							
							
							<el-divider >{{$t('match.apitis19')}}</el-divider>
							<el-card   shadow="never" class="mb-3">
							  <div style="font-weight: bold; margin-bottom: 10px;">
							  {{$t('match.apitis24')}}
							  
							  <code>sign = MD5(key + t)</code>
							  </div>
							  <el-table :data="[
								{ name: 'class_id', type: 'int', desc: $t('match.apitis10') },
							    { name: 'match_id', type: 'int', desc: $t('match.id') },
							    
							    { name: 'stream', type: 'string', desc: $t('match.apitis20') },
							    { name: 't', type: 'int', desc: $t('match.apitis21')},
							    { name: 'hls_url', type: 'string', desc: $t('match.apitis22') },
							    { name: 'sign', type: 'string', desc: $t('match.apitis23') },
							  ]" border style="width: 100%">
							    <el-table-column prop="name" :label="$t('live.apitis54')" width="160" />
							    <el-table-column prop="type" :label="$t('live.type')" width="120" />
							    <el-table-column prop="desc" :label="$t('live.apitis18')" />
							  </el-table>
							</el-card>
							
							
							
							
						</el-card>
					</div>
				   <div class="doc-page" v-if="apiType=='1'">
				     <el-card shadow="hover">
				       <h4>{{$t('match.apitis1')}}</h4>
				       <p class="desc">{{$t('match.apitis2')}}</p>
				 
				       <el-divider>{{$t('live.apitis3')}}</el-divider>
				       <el-card shadow="never" body-style="padding: 20px; background: #fdfdfd;">
				         <div style="font-size: 14px; line-height: 2;">
				       
				           <p>
				             <strong style="width: 100px; display: inline-block;">{{$t('live.apitis4')}}：</strong>
				             <span style="color: #409EFF; font-weight: bold;">{{info.api_url}}
							 <span class="iconCopy" @click="copyText(info.api_url)"><i class="iconfont icon-fuzhi"></i></span></span>
				           </p>
						   
						   <p v-if="info.api_url2">
						     <strong style="width: 100px; display: inline-block;">{{$t('live.apitis4_1')}}：</strong>
						     <span style="color: #409EFF; font-weight: bold;">{{info.api_url2}}
						   						 <span class="iconCopy" @click="copyText(info.api_url2)"><i class="iconfont icon-fuzhi"></i></span></span>
						   			<span class="ml-2">({{$t('live.apitis4_2')}})</span>
						   </p>
				       
				           <p>
				             <strong style="width: 100px; display: inline-block;">{{$t('live.apitis5')}}：</strong>
				             <span>POST</span>
				           </p>
				       
				           <p>
				             <strong style="width: 100px; display: inline-block;">{{$t('live.apitis6')}}：</strong>
				             <span>application/json 或 x-www-form-urlencoded</span>
				           </p>
				       
				           <p>
				             <strong style="width: 100px; display: inline-block;">{{$t('live.apitis7')}}：</strong>
				             <span>MD5</span>
				           </p>
				       
				           <p>
				             <strong style="width: 100px; display: inline-block; color: #F56C6C;">{{$t('live.apitis8')}}：</strong>
				             <span style="font-family: monospace; background: #f2f2f2; padding: 2px 6px; border-radius: 4px; color: #333;">
				               {{con.jc.api_key}}
				               <span class="iconCopy" @click="copyText(con.jc.api_key)"><i class="iconfont icon-fuzhi"></i></span>
							   
				             </span>
				           </p>
						   
						   
						   <p>
						     <strong style="width: 100px; display: inline-block; color: #F56C6C;">client：</strong>
						     <span style="font-family: monospace; background: #f2f2f2; padding: 2px 6px; border-radius: 4px; color: #333;">
						       {{info.uid}}
						       <span class="iconCopy" @click="copyText(info.uid)"><i class="iconfont icon-fuzhi"></i></span>
						   						   
						     </span>
						   </p>
						   			       
				       
				         </div>
				       </el-card>
		
				 
				       <el-divider>{{$t('live.apitis9')}}</el-divider>
				       <el-table :data="apiParamList" border style="width: 100%">
				         <el-table-column prop="name" :label="$t('live.apitis16')" width="150" />
				         <el-table-column prop="type" :label="$t('live.type')" width="100" />
				         <el-table-column prop="required" :label="$t('live.apitis17')" width="80" />
				         <el-table-column prop="desc" :label="$t('live.apitis18')" />
				       </el-table>
				 
				      <el-divider>{{$t('live.apitis19')}}</el-divider>
				      <el-card shadow="never" class="mb-3">
				        <div class="text-block">
				          <p>{{$t('live.apitis20')}} <code>sign</code>，{{$t('live.apitis21')}}。</p>
				      
				          
				          <p style="font-weight:bold;">{{$t('live.apitis22')}}：</p>
				          <ul>
				            <li>{{$t('live.apitis23')}} <code>key</code>（{{$t('live.apitis24')}}）</li>
				            <li><code>timestamp</code> {{$t('live.apitis25')}}</li>
				            <li><code>nonce</code> {{$t('live.apitis26')}}</li>
				            <li>{{$t('live.apitis27')}} <code>client</code>、<code>startDate</code> 、<code>endDate</code>{{$t('live.apitis28')}}</li>
				          </ul>
				      
				          <p style="font-weight:bold;">{{$t('live.apitis29')}}：</p>
				          <ol>
				            <li>{{$t('live.apitis30')}} <code>sign</code> {{$t('live.apitis31')}}</li>
				            <li>{{$t('live.apitis32')}} <strong>{{$t('live.apitis33')}}</strong> {{$t('live.apitis34')}}</li>
				            <li>{{$t('live.apitis35')}}：<br />
				              <code>signStr = key + timestamp + nonce + k1 + v1 + k2 + v2 + ...</code>
				            </li>
				            <li>{{$t('live.apitis36')}} <code>md5</code> {{$t('live.apitis37')}}</li>
				            <li>{{$t('live.apitis38')}} <code>sign</code> {{$t('live.apitis39')}}</li>
				          </ol>
				      
				          <el-descriptions :title="$t('live.apitis40')" :column="1" border>
				            <el-descriptions-item label="key">
							abc123456
							
							</el-descriptions-item>
				            <el-descriptions-item label="client">FF0001</el-descriptions-item>
				            <el-descriptions-item label="startDate">2025-01-01</el-descriptions-item>
				            <el-descriptions-item label="endDate">2025-01-01</el-descriptions-item>
				            <el-descriptions-item label="timestamp">1720000000</el-descriptions-item>
				            <el-descriptions-item label="nonce">abcxyz</el-descriptions-item>
				            <el-descriptions-item v-if="from.type==2" label="TemplateName">hd</el-descriptions-item>
							
				          </el-descriptions>
				      
				          <p style="font-weight:bold; margin-top: 10px;">1. {{$t('live.apitis41')}}：</p>
				          <el-card shadow="never">
				            client=FF0001<br />
				            endDate=2025-01-01<br />
				            nonce=abcxyz<br />
							startDate=2025-01-01<br />
				            timestamp=1720000000
							<span v-if="from.type==2"><br />TemplateName=hd</span>
				          </el-card>
				      
				          <p style="font-weight:bold; margin-top: 10px;">2. {{$t('live.apitis42')}}：</p>
				          <el-card shadow="never">
				            abc1234561720000000abcxyzclientFF0001endDate2025-01-01nonceabcxyzstartDate2025-01-01timestamp1720000000
				          </el-card>
				      
				          <p style="font-weight:bold; margin-top: 10px;">3. {{$t('live.apitis44')}} md5：</p>
				          <el-card shadow="never">
				            sign = md5({{$t('live.apitis44')}}) = <span style="color:#409EFF;">
								<span >6667eb87e7859a930038965ec2b682f2</span>
								</span>
				          </el-card>
				      
				          
				        </div>
				      </el-card>
					  
					 
						<!-- 4. 请求示例 -->
						<el-divider>{{$t('live.apitis45')}}</el-divider>
						<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
						  <pre  style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none; ">
		{
			"client": "FF0001",
			"startDate": "2025-01-01",
			"endDate": "2025-01-01",
			"timestamp": 1720000000,
			"nonce": "abcxyz",
			"sign": "6667eb87e7859a930038965ec2b682f2",
		}
						  </pre>
						  
						</el-card>
						
						<!-- 5. 响应示例 -->
						<el-divider>{{$t('live.apitis46')}}</el-divider>
						<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
						  <pre  style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none;">
		{
		    "code": 200,
		    "msg": "success",
		    "data": [
		        {
		            "match_id": 4261024,
		            "class_id": 1,
		            "class_name": "足球",
		            "match_time": "2025-01-01 00:00:00",
		            "short": "挪超",
		            "competition_name": "挪威超级联赛",
		            "home_name": "布兰",
		            "away_name": "海于格松"
		        }
		    ],
		    "requestId": "mgw5zbdpcabb98eb2b6f3694"
		}
						  </pre>
						  
						  
						</el-card>
		
					   
					   
				 
				 
				      <el-divider >{{$t('live.apitis47')}}</el-divider>
				      <el-card   shadow="never" class="mb-3">
				        <div style="font-weight: bold; margin-bottom: 10px;">{{$t('match.apitis9')}}</div>
				        <el-table :data="[
				          { name: 'match_id', type: 'int', desc: $t('match.id') },
				          { name: 'class_id', type: 'int', desc: $t('match.apitis10') },
				          { name: 'class_name', type: 'string', desc: $t('match.apitis11') },
				          { name: 'match_time', type: 'string', desc: $t('match.apitis12')},
				          { name: 'short', type: 'string', desc: $t('match.apitis13') },
				          { name: 'competition_name', type: 'string', desc: $t('match.com_name') },
				          { name: 'home_name', type: 'string', desc: $t('match.apitis14') },
				          { name: 'away_name', type: 'string', desc: $t('match.apitis15') },
				        ]" border style="width: 100%">
				          <el-table-column prop="name" :label="$t('live.apitis54')" width="160" />
				          <el-table-column prop="type" :label="$t('live.type')" width="120" />
				          <el-table-column prop="desc" :label="$t('live.apitis18')" />
				        </el-table>
				      </el-card>
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
				 
				       <el-divider >{{$t('live.apitis60')}}</el-divider>
				       <el-card shadow="never">
				         <el-table :data="[
				           { code: 200, message: 'success', desc: $t('live.apitis61') },
				           { code: 400, message: $t('live.apitis68'), desc: $t('live.apitis62') },
				           { code: 401, message: $t('live.apitis69'), desc: $t('live.apitis63') },
				           { code: 403, message: $t('match.apitis7'), desc: $t('match.apitis8') },
				           { code: 405, message: $t('live.apitis70'), desc: $t('live.apitis64') },
				           { code: 500, message: $t('live.apitis71'), desc: $t('live.apitis65') }
				         ]" border style="width: 100%">
				           <el-table-column prop="code" :label="$t('live.apitis66')" width="100" />
				           <el-table-column prop="message" :label="$t('live.apitis67')" width="220" />
				           <el-table-column prop="desc" :label="$t('live.apitis18')" />
				         </el-table>
				       </el-card>
				       
				     </el-card>
				   </div>
				 </template>
		
		
				<div slot="footer" class="dialog-footer">
					<el-button @click="apiModel = false">{{$t('safe.close')}}</el-button>
					
				</div>
			</el-dialog>
			
			
			
			<matchModel @hide="matchApiModel=false" :matchApiModel="matchApiModel" :isphone="layout.is_phone"></matchModel>
			
			<comRule  @hide="comRuleModel=false" :comRuleModel="comRuleModel" :isphone="layout.is_phone"></comRule>
		

	</div>
</template>

<script>
	import matchModel from '@/components/api/match.vue';
	import comRule from '@/components/api/comRule.vue';
	import videojs from 'video.js';
	import 'video.js/dist/video-js.css';
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch,
			matchModel,
			comRule
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				comRuleModel:false,
				matchApiModel:false,
				infoModel:false,
				infoLoad:false,
				infoList:[],
				playModel:false,
				playData:{
					load:false,
					url:''
				},
				isDialogOpened: false, 
				player: null,
				createModel: false,
				editIndex: -1,
				rule:[],
				apiModel:false,
				apiType:"1",
				//搜索數据
				from: {
					short: '',
					home: '',
					away: '',
					name: '',
					username:'',
					status:-1,
					type:-1,
					rule_id:'',
					time:[],
				},
				info:{is_have_pull:0},
				con:{tran:[],is_more:0,jc:{api_key:''}},
				auth_val: 'Match',

				preUrl: "data/livematchList", //列表地址
				// delAllUrl: "user/delAdminAll", //批量删除地址
				delUrl: "data/delLiveRecord", //删除單条地址
				addUrl: "data/addLiveUserConfig", //添加/修改地址
				editStatusUrl:"user/editStatusAgent",//修改狀態地址
				type:"1",
				tableData: [],
				form: {
                    list:[],
					api_key:""
				},
				rules: {
					ip_data: [{
						required: true,
						message: this.$t('match.inpip_data'),
						trigger: 'blur',
					}],
					api_key: [{
						required: true,
						message: this.$t('live.inpnowkey'),
						trigger: 'blur',
					}],
					tid: [{
						required: true,
						message: this.$t('record.selmodel'),
						trigger: 'blur',
					}],
				
					
					
				},
				cloud:[],
				agent_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
			apiParamList() {
			    const list = [
			      { name: 'client', type: 'string', required: this.$t('live.yes'), desc: this.$t('match.client')},
			      { name: 'startDate', type: 'string', required: this.$t('live.yes'), desc: this.$t('match.apitis3') },
			      { name: 'endDate', type: 'string', required: this.$t('live.yes'), desc: this.$t('match.apitis4') },
			      
			      { name: 'timestamp', type: 'int', required: this.$t('live.yes'), desc: this.$t('live.apitis13') },
			      { name: 'nonce', type: 'string', required: this.$t('live.yes'), desc: this.$t('live.apitis14') },
			      { name: 'sign', type: 'string', required: this.$t('live.yes'), desc: this.$t('live.apitis15') },
				  { name: 'language', type: 'string', required: this.$t('live.no'), desc: this.$t('match.apitis5') },
				  { name: 'classType', type: 'int', required: this.$t('live.no'), desc: this.$t('match.apitis6') }
				  
				 
			    ];
			
			    // 如果是推流（type=1），过滤掉仅限播放用的字段
			    return list.filter(item => {
			        return true;
			      });
			  }
		},
		created() {
			this.commonList(['matchData']);
		},
		methods: {
			openPlay(url){
				this.playModel = true
				this.playData.url = url
				if (this.isDialogOpened) {
				  this.previewStream();
				}
			},
			onDialogOpened() {
			    this.isDialogOpened = true;
			    // 如果接口数据已经回来，直接初始化播放器
			    if (this.playData.url) {
			      this.previewStream();
			    }
			  },
			  onDialogClosed() {
			    this.isDialogOpened = false;
			    this.destroyPlayer();
			    this.playData.url = ''; // 清空旧地址
			  },
			previewStream() {
			      // 加一个小延迟，确保 dialog 渲染动画结束
			        setTimeout(() => {
			          this.$nextTick(() => {
			            if (this.player) {
			              this.player.dispose();
			            }
			      
			            const videoElement = this.$refs.videoPlayer;
			            if (!videoElement || !document.body.contains(videoElement)) {
			              console.warn('video element not in DOM yet');
			              return;
			            }
			      
			            this.player = videojs(videoElement, {
			              autoplay: true,
			              controls: true,
			              preload: 'auto',
			              sources: [{
			                src: this.playData.url,
			                type: 'application/x-mpegURL'
			              }]
			            });
			          });
			        }, 200); // 加 200ms 延迟
			    },
			    destroyPlayer() {
			      if (this.player) {
			        this.player.dispose();
			        this.player = null;
			      }
			    },
			handleIpInput(val) {
				let num = 5
				console.log(num)
			    const lines = val.split('\n');
			    if (lines.length > num) {
			      this.form.ip_data = lines.slice(0, num).join('\n'); // 只保留前 50 行
			      this.$message.warning(this.$t('match.limitSource'));
			    }
			  },
			selDomain(){
				this.marr = []
				this.commonList('checkUserRecord',this.form.ld_id);
			},
			limitRebate(val) {
			    const n = Number(val)
			    if (!Number.isFinite(n)) { this.form.rebate = null; return }
			    const clamped = Math.min(100, Math.max(0, n))
			    this.form.rebate = Math.trunc(clamped)   // 只要整数
			  },
            validateParent(rule, value, callback) {
                if (this.form.id > 0) {
                    if (!value) {
                        return callback(new Error(this.$t('agentList.passwordLength'))); // 只有 type == 2 时才校验
                    }
                }
                callback(); // 其他情况不校验
            },
			//提交
			submit() {
				if (this.form.password != this.form.password2) {
					this.$message({
						message: this.$t('agentList.differentPasswords'),
						type: 'error'
					});
					return
				}
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('agentList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			checkKeyInp2(val){
				const clear = val.replace(/[^a-zA-Z0-9]/g, '').slice(0, 32);
				this.form.api_key = clear;
			},
			checkKeyInp3(val){
				const clear = val.replace(/[^a-zA-Z0-9]/g, '').slice(0, 32);
				this.form.call_key = clear;
			},
			
			checkPlayInfo(data){
				this.infoModel = true
				//this.info.is_have_pull==2
				this.info.is_have_pull==2
				this.checkPlayInfoApi(data)
				
				
			},
			
			checkPlayInfoApi(data) {
				this.infoLoad = true;
				this.axios.post('/admin/data/checkAllPlays', {
					type_id: data.type_id,
					match_id: data.match_id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list

					this.infoList = list;
					this.info.is_have_pull=1
					// if(this.infoList.length>0){
					// 	this.info.is_have_pull=1
					// }else{
					// 	this.info.is_have_pull=0
					// }
			
					this.infoLoad = false;
				}).catch(err => {
					// 失敗
					this.infoLoad = false;
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				
				if (!e) {
					// 初始化表單
					this.form = {
						list: [
							{cloud_id:4,push:'',push_key:'',pull:'',pull_key:'',status:true}
						],
						call_key:this.con.jc.call_key,
						call_url:this.con.jc.call_url,
						open:"1"
					}
					if(this.con.tran.length!=0){
						this.form.list = [...this.con.tran]
					}
					
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						name: e.row.name,
						min: e.row.min,
						max:  e.row.max,
						type:  e.row.type,
						rebate:  e.row.rebate,
						level:  e.row.level,
						
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			
			rangKey(type){
				const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
				    let key = '';
				    for (let i = 0; i < 32; i++) {
				      key += chars.charAt(Math.floor(Math.random() * chars.length));
				    }
					
					if(type==1){
						this.form.api_key = key
					}else if(type==2){
						this.form.call_key = key
					}else{
						//this.form.back_key = key
					}
				
				    
			},
			
			addTranscode() {
			    this.form.list.push({cloud_id:4,push:'',push_key:'',pull:'',pull_key:'',status:true});
			  },
			  removeTranscode(index) {
			      this.form.list.splice(index, 1);
			    },
			//公共列表
			commonList(type,id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.cloud = list.cloud

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			addOrEditResult(){
				//console.log('addOrEditResult')
			},
			
			
			
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
            handleAvatarSuccessTg(res, file) {
				this.form.tg_qr = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.tgQrUrl = res.encryption.data.list.url
				}
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.con = e.con
				this.info = e.info
				
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					type:-1,
					rule_id:'',
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important;
}
</style>
